export default {
  ADD_displayName(state, value) {
    state.displayNames.push(value);
  },
  SET_displayNames(state, value) {
    if (state.displayNames.includes(value)) return;
    state.displayNames = value;
  },
};
